<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Homeowner Article Details"></fury-breadcrumbs>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>

        <div class="describ-item">
          <div class="col-title">
            <h3>{{articleDetails?.title}}</h3>
          </div>
        </div>
        <div class="imgBox">
          <img [src]="articleDetails?.bannerImage">
        </div>

        <div>
          <h3>Category</h3>
          <div class="catbox">
            <span *ngFor="let category of articleDetails?.categories">
              <!-- <img [src]="category?.bannerImage" alt="category"> -->
              <img [src]="category?.bannerImage ?  bannerImage : '../../../../../assets/img/no_thumbnail.jpg'" alt="">
              <p>{{category?.title}}</p>
            </span>
          </div>
        </div>
        <div class="authorprt">
          <h3>Author(s)</h3>
          <span>
            <img [src]="articleDetails?.author?.profilePicture">
            <p>{{articleDetails?.author?.fullName}}</p>
          </span>
        </div>
        
        <div class="describ-item">
          <div class="col-title">
            <h3>Published Date</h3>
          </div>
          <div class="col-desc">
            
            <p>{{articleDetails?.publishDate | date : 'longDate'}}</p>
           
          </div>
        </div>
        
        <div class="describ-item">
          <div class="col-title">
            <h3>Description</h3>
          </div>
          <div class="col-desc">
            
            <p [innerHTML]="articleDetails?.description"></p>
           
          </div>
        </div>
        
        <div class="describ-item">
          <div class="col-title">
            <h3>Meta Title</h3>
          </div>
          <div class="col-desc">
            
            <p>{{articleDetails?.metaTitle}}</p>
           
          </div>
        </div>
        
        <div class="describ-item">
          <div class="col-title">
            <h3>Meta Description</h3>
          </div>
          <div class="col-desc">
            
              <p>{{articleDetails?.metaDescription}}</p>
           
          </div>
        </div>
        
      
    </fury-page-layout-content>
  </fury-page-layout>
  
  
  
    
  

